import { render, staticRenderFns } from "./CardPartnerTimelineSetting.vue?vue&type=template&id=524c3886&scoped=true&"
import script from "./CardPartnerTimelineSetting.vue?vue&type=script&lang=js&"
export * from "./CardPartnerTimelineSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c3886",
  null
  
)

export default component.exports